import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';

// CONSTANTS
import { ROUTE_SHOWS_AND_MOVIES_DISCOVER } from '@/constants/routes';

// UTILITY
import { getPlaceholderUrl } from '@/utility/content';

// COMPONENTS
import RouterLink from '@/components/Link';

// STYLES
import { Container } from '../styles';

// HELP
import ActionsMenu from './ActionsMenu';

const SearchCardContentCrew = ({ className, data, link, analyticsLocation, actions, ...props }) => {
  const [t] = useTranslation();

  const image = React.useMemo(
    () =>
      data.thumbnail ||
      getPlaceholderUrl({ title: data.name, width: 71, height: 106, bgColor: 'F5F6F7' }),
    [data.thumbnail],
  );

  const to = React.useMemo(() => link || `${ROUTE_SHOWS_AND_MOVIES_DISCOVER}?crew=${data.id}`, [
    link,
    data.id,
  ]);

  return (
    <Container {...props} className={clsx('search-card', `search-card-content-crew`, className)}>
      {!!actions.length && <ActionsMenu className="search-card__button" actions={actions} />}
      <RouterLink className="search-card__link" to={to} location={analyticsLocation} />

      <div className="search-card__column-group">
        <div className="search-card__column">
          <div className="search-card__image search-card-content-crew__image">
            <img src={image} alt="app-logo" />
          </div>
        </div>

        <div className="search-card__column">
          <Typography variant="h5">{data.name}</Typography>
          {!!data.role && (
            <Typography className="p4" variant="inherit" component="span" color="textSecondary">
              {t('common.role')}: {t(`common.${data.role}`)}
            </Typography>
          )}
        </div>
      </div>
    </Container>
  );
};

SearchCardContentCrew.defaultProps = {
  className: '',
  link: '',
};

SearchCardContentCrew.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
  link: PropTypes.string,
  analyticsLocation: PropTypes.string,
  actions: PropTypes.array.isRequired,
};

export default React.memo(SearchCardContentCrew);
